__turbopack_context__.v({
  "advantages": "style-module-scss-module__wFjJka__advantages",
  "arrows": "style-module-scss-module__wFjJka__arrows",
  "name": "style-module-scss-module__wFjJka__name",
  "slide": "style-module-scss-module__wFjJka__slide",
  "swiper": "style-module-scss-module__wFjJka__swiper",
  "text": "style-module-scss-module__wFjJka__text",
  "title": "style-module-scss-module__wFjJka__title",
  "wrapper": "style-module-scss-module__wFjJka__wrapper",
});
